namespace $ {

	/** Generate a Word-compatible HTML document from a filled form */
	export function $bog_formigo_export_doc(
		title: string,
		workspace_name: string,
		fields: { label: string, value: string }[],
	): Blob {

		const escape = (s: string) => s
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')

		let rows = ''
		for (const { label, value } of fields) {
			rows += `<tr>
				<td style="padding:8px;border:1px solid #ddd;background:#f9f9f9;font-weight:bold;width:35%">${escape(label)}</td>
				<td style="padding:8px;border:1px solid #ddd">${escape(value).replace(/\n/g, '<br/>')}</td>
			</tr>`
		}

		const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
			xmlns:w="urn:schemas-microsoft-com:office:word"
			xmlns="http://www.w3.org/TR/REC-html40">
		<head>
			<meta charset="utf-8">
			<style>
				body { font-family: Calibri, Arial, sans-serif; margin: 2cm; }
				h1 { color: #333; font-size: 18pt; margin-bottom: 4pt; }
				h2 { color: #666; font-size: 14pt; margin-bottom: 12pt; font-weight: normal; }
				table { width: 100%; border-collapse: collapse; margin-top: 12pt; }
				td { vertical-align: top; }
				.footer { margin-top: 24pt; font-size: 9pt; color: #999; }
			</style>
		</head>
		<body>
			<h1>${escape(workspace_name)}</h1>
			<h2>${escape(title)}</h2>
			<table>${rows}</table>
			<p class="footer">Generated by Formigo on ${new Date().toLocaleDateString('en-GB')}</p>
		</body>
		</html>`

		return new Blob([html], { type: 'application/msword' })
	}

}
